import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=c4ff1ce0&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=c4ff1ce0&prod&lang=scss"
import style1 from "./Register.vue?vue&type=style&index=1&id=c4ff1ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ff1ce0",
  null
  
)

export default component.exports